// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__LwJlM","Main_article":"Main_Main_article__nYxap"};